import { Quote } from 'lucide-react'

export default function TestimonialCard({ name, role, image, quote, program }) {
  return (
    <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
      <Quote className="w-12 h-12 text-secondary mb-4" />
      <p className="text-gray-700 italic mb-6 text-lg">"{quote}"</p>
      <div className="flex items-center space-x-4">
        <img 
          src={image} 
          alt={name} 
          className="w-16 h-16 rounded-full object-cover border-4 border-secondary"
        />
        <div>
          <h4 className="font-bold text-primary">{name}</h4>
          <p className="text-sm text-gray-600">{role}</p>
          {program && <p className="text-xs text-secondary font-semibold">{program}</p>}
        </div>
      </div>
    </div>
  )
}
